<template>
<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Starter page</h4>
        </div>
    </div>
</div>

</template>